<template>
  <div class="left_block courses admin">
    <p class="header">
      <span class="left">Все курсы</span>
    </p>

    <CoursesFilter
      :branches-list="branchesList"
      :rows="rows"
      @restore="restoreCourses"
      :categories-list="categoriesList"
      @duplicate="duplicateCourse"
      @delete="deleteChecked"
      @create-course="openCourseCreate"
      @handle-change="loadData"
      :search="search"
    />

    <CoursesTable
      :branches-list="branchesList"
      :is-loading="isLoading"
      @restore="restoreCourse"
      @delete="deleteCourse"
      @changePage="changePage"
      @init-sort="initSort"
      :categoriesList="categoriesList"
      :courses-list="coursesList"
      :rows="rows"
      :total-count="totalCount"
    />
  </div>
</template>

<script>
import CoursesFilter from '@/components/admin/all-courses/CoursesFilter'
import CoursesTable from '@/components/admin/all-courses/CoursesTable'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    CoursesFilter,
    CoursesTable
  },
  data() {
    return {
      rows: {
        checked: []
      },
      search: {
        name: '',
        category_id: 0,
        branch_id: 0,
        status: 2,
        trashed: false,
        page: 1,
        sort: 'surname',
        sort_type: 'desc'
      },
      isLoading: true
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    coursesList() {
      return this.$store.state.courses.coursesList.courses
    },
    totalCount() {
      return this.$store.state.courses.coursesList.total
    },
    categoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    },
    branchesList() {
      return this.$store.state.right.rightBranchesList
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType
      this.search.sort = fieldName
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const qs = require('qs')
      const params = {}
      Object.keys(this.search).forEach((el) => {
        if (el === 'status' && this.search[el] === 2) {
          return
        }
        if ((this.search[el] && this.search[el] !== 0) || el === 'status') {
          params[el] = this.search[el]
        }
      })
      this.$axios2
        .get('courses?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false
          this.$store.commit('setCoursesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    changePage(pageNumber) {
      this.search.page = pageNumber
      this.loadData()
    },
    openCourseCreate() {
      this.$router.push('/all-courses/create')
    },
    deleteCourse(course) {
      this.$axios2
        .delete('courses/' + course.id)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    deleteChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.deleteCourse(this.rows.checked[i])
      }
      this.rows.checked = []
    },
    restoreCourse(course) {
      this.$axios2
        .patch('courses/' + course.id)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    restoreCourses() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.restoreCourse(this.rows.checked[i])
      }
      this.rows.checked = []
    },
    duplicateCourse() {
      this.rows.checked.forEach((course) => {
        let newCourse = {
          description: course.description,
          category_id: course.category_id,
          days_limit: course.days_limit,
          name: course.name + ' - копия',
          status: 0
        }
        this.$axios2
          .post('courses', newCourse)
          .then(() => {
            this.loadData()
            this.$buefy.toast.open(toastInfo())
          })
          .catch(this.$errorToast)
      })
      this.rows.checked = []
    }
  }
}
</script>
